<template>
    <input type="hidden"
           :id="id"
           v-model="dataValue" />

</template>

<script>
  export default {
      name: 'InputHidden',
      props: {
          value: {
              type: String | Number,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              dataValue: ''
          }
      },
      methods: {
      }
  }
</script>